import WinnerParticipantPanel from './winnerParticipantPanel.container'

export default WinnerParticipantPanel;